import type { FaireProductEntity } from "../../entity_types/product";

export const p_vky92s65yd: FaireProductEntity = {
  token: "p_vky92s65yd",
  type: "product",
  name: "Copper Sphere - Pure Michigan Copper",
  brandToken: "b_en1yij2pf6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a3b58500e7c9df8d47a1f72ee7f8ef2ec7c0a4277247180fe255d55f1f86a35b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3deacb01433ecff878b82266888bd0c13437eee5f01db95aedf1cef1b09dc8c5.jpeg",
    "https://cdn.faire.com/fastly/4f902cc9889a6dd36eb7cd7759d09a54501e3b9f9bc710cbcc08aa8ec0393480.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "The beautiful Copper Sphere is not only visually eye catching but is a remarkable for physical healing and energy protection. Copper is the best stone to heal energy in the root chakra making it ideal to use in meditation. Copper offers a grounding energy to connect one’s energy with the earths energy.  It can quickly unlock energies with its smooth surface all around, allowing to gain prosperity and a progressive openness towards life elements. It can also help prevent nightmares and protect from harmful EMFs. A unique gift for avid crystal lovers. Perfect size to carry in pocket or bags. Great addition to mini crystal grids. Make our high quality Copper pieces a part of your store collection to offer a great variety to your customers.\n\nSize: 1.1 inches\nSold: Per piece\nOrigin: USA",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:44.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
